import { useCallback } from 'react'
import { Button } from '@percent/lemonade'
import type { LinkButton } from '@percent/cause-dashboard/storyblok/types/storyblok-components'
import styles from './RichTextLinkButton.module.scss'

export type RichTextLinkButtonProps = {
  blok: LinkButton
}

/** Storyblok `link_button` embedded in richtext — primary CTA opening the URL in a new tab. */
export function RichTextLinkButton({ blok }: Readonly<RichTextLinkButtonProps>) {
  const href = blok.link?.trim() ?? ''
  const label = blok.label?.trim() ?? ''

  const onClick = useCallback(() => {
    if (!href) return
    window.open(href, '_blank', 'noopener,noreferrer')
  }, [href])

  if (!label) {
    return null
  }

  return (
    <div className={styles.linkButtonBlock}>
      <Button variant="primary" stretch onClick={onClick} disabled={!href}>
        {label}
      </Button>
    </div>
  )
}
